module.exports = __webpack_public_path__ + "img/printmystory.8d4f7126.png";